<template>
  <div class="col-6 col-sm-12 no-relative-position">
    <template
      v-if="objectData.ratingCount"
    >
      <div class="rating-container">
        <div class="rating-stars">
          <rating-stars
            v-b-tooltip.hover.noninteractive
            :title="ratingWord"
            :percent="percent"
          />
          <em>
            {{ ratingAvgOneDecimal }}
          </em>
        </div>
        {{ objectData.ratingsSummary }}
        <div class="rating-amount">
          {{ $t('common:ratingCount', {count:objectData.ratingCount}) }}
        </div>
      </div>
    </template>
    <div
      v-else
      style="height: 2em; overflow: hidden;"
    />
  </div>
</template>

<script>
import RatingCalc from 'mixins/RatingCalc';

import { VBTooltip } from 'bootstrap-vue';
import 'scss/bootstrap/vue/components/tooltip.scss';
import RatingStars from 'components/RatingStars.vue';

export default {
  name: 'SearchObjectRatingSummary',
  components: {
    RatingStars,
  },
  directives: { 'b-tooltip': VBTooltip },
  mixins: [RatingCalc],
  props: {
    objectData: {
      required: true,
      type: Object,
    },
  },
  computed: {
    percent() {
      return this.rcMixin_percentage(this.objectData.ratingAverage);
    },
    ratingAvgOneDecimal() {
      return this.rcMixin_averageOneDecimal(this.objectData.ratingAverage);
    },
    ratingWord() {
      return this.rcMixin_ratingWord(this.objectData.ratingAverage, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
  .rating-container {
    text-align: right;

    @media #{$media_xs} {
      margin-top: 0.5em;
      text-align: left;
    }

    .rating-stars {
      justify-content: flex-end;

      @media #{$media_xs} {
        justify-content: flex-start;
      }
    }

    .rating-amount {
      @include font_size_s;

      margin: 0 0 0.75em;
    }
  }
</style>
